import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { installFormsApi } from '@/api/index';

export const fetchStaticAdv = createAsyncThunk(
  'staticAdv',
  async (_, thunkAPI) => {
    try {
      const response = await installFormsApi.getStaticAdv();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchInstallSidesAdv = createAsyncThunk(
  'staticAdv',
  async (_, thunkAPI) => {
    try {
      const response = await installFormsApi.getInstallSidesAdv();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
